import { Input } from '@/components/ui/input';

export function EffectiveDateInput({
  value,
  onChange,
  label,
  orientation = 'horizontal',
  readOnly,
  min,
  max,
  required = false,
  disabled,
  stretch,
}: {
  value: string | undefined;
  onChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  orientation: 'horizontal' | 'vertical';
  min: string | undefined;
  max: string | undefined;
  required: boolean | undefined;
  readOnly?: boolean;
  disabled?: boolean;
  stretch?: boolean;
}) {
  return (
    <div
      className={`flex ${orientation === 'horizontal' ? 'items-center gap-4' : 'w-full flex-col'}`}
    >
      {label && (
        <label
          className={`${orientation === 'horizontal' ? `${stretch ? 'w-1/3' : 'w-1/5'}` : 'mb-2'} font-semibold leading-[1.5rem]`}
        >
          {label}
          {required && <span className="text-red-400">*</span>}
        </label>
      )}
      <div
        className={`${orientation === 'horizontal' ? `${stretch ? 'w-2/3' : 'w-2/5'}` : ''} !mt-0`}
      >
        <div className="flex w-full items-center">
          <Input
            placeholder="Type here"
            value={value}
            onChange={onChange}
            disabled={readOnly || disabled}
            required={required}
            type="date"
            min={min}
            max={max}
          />
        </div>
      </div>
    </div>
  );
}
